/**
 * @author Geider Arevalo
 * @since v0.0.1
 * @date 7/1/22
 */
import React, {memo, useMemo} from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';
import styles from '../../index.less';
import {useAuditData} from '@/modules/auditorAudits/hooks/useAuditData';
import SectionBox from '../SectionBox';

const ResponseList = () => {
  const {dataIntro, dataSections, dataContacts} = useAuditData();

  const countData = useMemo(() => {
    let countIncidences = 0;
    let countTasks = 0;
    dataSections?.forEach((section) => {
      section?.questions?.forEach((question) => {
        question?.issuesAudit?.forEach((issueAudit) => {
          countIncidences++;
          issueAudit?.tasksAudit?.forEach((task) => {
            task && countTasks++;
          });
        });
      });
    });
    return {countIncidences, countTasks};
  },[dataSections]);

  return (
    <div className="md:px-48 w-full h-full  wrapper-run-audit-content">
      <div className={classNames('md:px-48 md:ml-10', styles.sectionsDrawerContent)} >
        <Scrollbars
          className={classNames(styles.scrollbars)}
          renderTrackHorizontal={props => <div {...props} style={{display: 'none'}} className="track-horizontal"/>}
        >
          <div className="mr-4 mt-2">
            <SectionBox
              countData={countData}
              key={'cover-fields}'}
              section={{}}
              id={'section-' + dataIntro?.[0]?._id}
              isCover
            />
            {dataSections?.map((item) => (<SectionBox key={item?._id} section={item} id={'section-'+item?._id} runAudit/>))}
            {dataContacts?.length > 0 && <SectionBox
              countData={countData}
              key={'contact-fields}'}
              section={{}}
              id={'section-' + dataContacts?.[0]?._id}
              isContact
            />}
          </div>

          <div id="just-to-go-the-bottom-page" />

        </Scrollbars>
      </div>
    </div>
  );
};

ResponseList.propTypes = {
};

export default memo(ResponseList);
